export const ORGANIZATION_TYPES = [
  'Health System',
  'Hospital',
  'Physician Group',
  'ASC',
  'Consulting',
  'Payer',
  'Vendor',
] as const;

export const CARE_SETTINGS = [
  'Acute Care Hospital — Inpatient',
  'Acute Care Hospital — Outpatient',
  'Ambulatory Surgery Center (ASC)',
  'Physician / Professional Billing',
  'Clinic / Ambulatory Care',
  'Post-Acute (SNF, Rehab, LTACH)',
  'Home Health',
  'Behavioral Health',
  'Hospice',
  'Ancillary Services (Lab, Imaging, DME)',
] as const;

export const BILLING_TYPES = [
  'Facility Billing',
  'Professional Billing',
  'Both',
] as const;

export const RCM_DEPARTMENTS = [
  'Patient Access / Registration',
  'Authorization / Utilization Review',
  'Coding (Facility)',
  'Coding (Professional)',
  'CDI',
  'Billing',
  'Follow-Up / AR',
  'Denials Management',
  'Appeals & Escalations',
  'Contracting / Payer Relations',
  'Compliance / Audit',
  'Finance / Revenue Integrity',
  'Clinical JOC / Payer Strategy',
] as const;

export const PAYER_FOCUS = [
  'Medicare FFS',
  'Medicare Advantage',
  'Medicaid',
  'Managed Medicaid',
  'Commercial',
  'Exchange Plans',
  'Workers Comp',
  'VA / TRICARE',
  'Self-Pay / Patient Collections',
] as const;

export const INTEREST_AREAS = [
  'Denial Prevention',
  'Appeals & Disputes',
  'Medical Necessity',
  'Coding Updates',
  'Regulatory Changes',
  'Compliance / Audit Risk',
  'Payer Policy Changes',
  'Contract Strategy',
  'Utilization Management',
  'Documentation Improvement',
  'Price Transparency',
  'Prior Authorization',
  'AI & Automation in RCM',
  'Revenue Optimization',
] as const;

export const ROLE_LEVELS = [
  'Staff',
  'Supervisor',
  'Manager',
  'Director',
  'Executive',
] as const;

export const US_STATES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
] as const;

export const MAC_REGIONS = [
  'Jurisdiction 1 (J1) — Noridian Healthcare Solutions (CA, HI, NV, AS, GU, CNMI)',
  'Jurisdiction 2/3 (J2/J3) — Noridian Healthcare Solutions (AK, AZ, ID, MT, ND, OR, SD, UT, WA, WY)',
  'Jurisdiction 4 (J4) — CGS Administrators (CO, NM, OK, TX)',
  'Jurisdiction 5 (J5) — WPS Government Health Administrators (IA, KS, MO, NE)',
  'Jurisdiction 6 (J6) — National Government Services (IL, MN, WI)',
  'Jurisdiction 7 (J7) — WPS Government Health Administrators (IN, MI)',
  'Jurisdiction 8 (J8) — Novitas Solutions (AR, LA, MS)',
  'Jurisdiction 9 (J9) — First Coast Service Options (FL, PR, USVI)',
  'Jurisdiction 10 (J10) — Palmetto GBA (AL, GA, TN)',
  'Jurisdiction 11 (J11) — Palmetto GBA (NC, SC, VA, WV)',
  'Jurisdiction 12 (J12) — Novitas Solutions (DE, DC, MD, NJ, PA)',
  'Jurisdiction K (JK) — National Government Services (CT, ME, MA, NH, NY, RI, VT)',
  'Jurisdiction F (JF) — CGS Administrators (KY, OH)',
  'DME MAC Jurisdiction A — CGS Administrators',
  'DME MAC Jurisdiction B — CGS Administrators',
  'DME MAC Jurisdiction C — Noridian Healthcare Solutions',
  'DME MAC Jurisdiction D — Noridian Healthcare Solutions',
] as const;
